import React from 'react'

const CheckBox = () => {
    return (

        <>
            <div className='containerCheckBoxMobile'>
                
                <div className='row_checkBoxMobile'>
                <label>Concordo em armazenar meus dados</label>
                <input type='checkbox' />
                </div>
            </div>

            <div className='containerCheckBoxMobile'>
            <div className='row_checkBoxMobile'>
                <label>Concordo em receber comunicações</label>
                <input type='checkbox' />
                </div>
            </div>
        </>
    )
}

export default CheckBox